import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notif-head" }
const _hoisted_2 = { class: "notif-head-ic" }
const _hoisted_3 = { class: "notif-head-txt" }
const _hoisted_4 = { class: "notif-sub" }
const _hoisted_5 = { class: "notif-list" }
const _hoisted_6 = {
  key: 0,
  class: "notif-empty"
}
const _hoisted_7 = { class: "empty-ic" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "notif-body" }
const _hoisted_10 = { class: "notif-item-title" }
const _hoisted_11 = {
  key: 0,
  class: "notif-dot"
}
const _hoisted_12 = { class: "notif-item-msg" }
const _hoisted_13 = { class: "notif-item-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "offset-y": "",
    "close-on-content-click": false,
    location: "bottom end",
    modelValue: _ctx.deschis,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deschis) = $event))
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, {
        icon: "",
        variant: "text",
        color: "white",
        class: "notif-btn",
        title: "Notificări"
      }), {
        default: _withCtx(() => [
          (_ctx.nrNecitite > 0)
            ? (_openBlock(), _createBlock(_component_v_badge, {
                key: 0,
                content: _ctx.nrNecitite > 99 ? '99+' : _ctx.nrNecitite,
                color: "#ff5722",
                "offset-x": "2",
                "offset-y": "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-bell-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content"]))
            : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-bell-outline", -1)
                ]))]),
                _: 1
              }))
        ]),
        _: 1
      }, 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "notif-card",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "#fff"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-bell-ring-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "notif-title" }, "Notificări", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.nrNecitite > 0 ? _ctx.nrNecitite + ' necitite' : 'Ești la zi'), 1)
            ]),
            _createVNode(_component_v_spacer),
            (_ctx.nrNecitite > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "notif-mark-all",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.citesteTot && _ctx.citesteTot(...args))),
                  title: "Marchează toate citite"
                }, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-check-all", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.notificari.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_icon, {
                      size: "30",
                      color: "#cbd5e1"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-bell-check-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "empty-t" }, "Nicio notificare", -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "empty-s" }, "Aici vor apărea aprobările și noutățile tale.", -1))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificari, (n) => {
              return (_openBlock(), _createElementBlock("button", {
                key: n.ID,
                class: _normalizeClass(["notif-item", { unread: !n.Citita }]),
                onClick: ($event: any) => (_ctx.onClick(n))
              }, [
                _createElementVNode("span", {
                  class: "notif-accent",
                  style: _normalizeStyle({ background: _ctx.culoare(n.Severitate) })
                }, null, 4),
                _createElementVNode("span", {
                  class: "notif-ico",
                  style: _normalizeStyle({ background: _ctx.culoare(n.Severitate) + '18', color: _ctx.culoare(n.Severitate) })
                }, [
                  _createVNode(_component_v_icon, { size: "19" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(n.Icon || 'mdi-bell-outline'), 1)
                    ]),
                    _: 2
                  }, 1024)
                ], 4),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createTextVNode(_toDisplayString(n.Titlu), 1),
                    (!n.Citita)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(n.Mesaj), 1),
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_v_icon, {
                      size: "11",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-clock-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(_ctx.timpRelativ(n.DataCreare)), 1)
                  ])
                ]),
                _createVNode(_component_v_icon, {
                  class: "notif-del",
                  size: "16",
                  onClick: _withModifiers(($event: any) => (_ctx.sterge(n)), ["stop"])
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ], 10, _hoisted_8))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}